// The cart's total cases as the header trigger and the side panel show it: null (shown as
// UNKNOWN_TOTAL) while the session's cart has not loaded, or when its read failed, so neither
// ever claims 0 cases it does not know (`useCartLinesLoaded`). With no session cart there is none
// to load, and the count is the store's.
import { totalCases } from './cartTotals';
import { useBasketStore } from './useBasketStore';
import { useCartLinesLoaded } from './useCartValue';

export function useCartCaseCount(): number | null {
  const loaded = useCartLinesLoaded();
  return useBasketStore((s) => (loaded ? totalCases(s.lines) : null));
}

/** The cart's distinct lines, the header badge's count, null under the same rule as the
 *  case count: the badge never claims 0 lines it does not know. */
export function useCartLineCount(): number | null {
  const loaded = useCartLinesLoaded();
  return useBasketStore((s) => (loaded ? s.lines.length : null));
}
